/* global facilitator_admin_vars */

import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'select2/dist/js/select2.full';

( function($) {
  function close_open_modal() {
    $.magnificPopup.close();
  }

  function open_please_wait() {
    var div = $('<div id="please-wait" />').addClass('please-wait-modal').html('Please wait');
    $.magnificPopup.open({
      closeOnContentClick: false,
      items: {
        src: div,
      },
      modal: true,
      type: 'inline',
    });
  }

  function alert_modal(params) {
    var defaults = {
      title: 'Alert',
      message: '',
      button_text: 'OK',
    };

    var merged = Object.assign(defaults, params);

    var modal = $('<div />').addClass('modal-alert-popup');
    var modal_title = $('<div />').addClass('modal-title').html(merged.title);
    var message = $('<p />').html(merged.message);
    var buttons = $('<div />').addClass('buttons');
    var ok_button = $('<button />').addClass('button-ok').html(merged.button_text).click(function(e) {
      e.preventDefault();
      close_open_modal();
    });
    buttons.append(ok_button);
    modal.append(modal_title).append(message).append(buttons);

    $.magnificPopup.open({
      closeOnContentClick: false,
      items: {
        src: modal,
      },
      modal: false,
      type: 'inline',
    });
  }

  function check_fields(fields, button) {
    var different = false;
    $.each(fields, function() {
      if (this.val() !== this.data('initial-value')) {
        different = true;
      }
    });

    if (different) {
      button.attr('disabled', false);
    } else {
      button.attr('disabled', true);
    }
  }

  function after_fields_changed(fields, button) {
    $.each(fields, function() {
      this.data('initial-value', this.val());
      button.attr('disabled', true);
    });
  }

  function display_error(reason) {
    var params = {
      title: 'Error Saving',
      message: reason + '<br /><br />Please try again.',
      button_text: 'OK',
    };
    alert_modal(params);
  }

  window.onload = function() {
    window.addEventListener('beforeunload', function(e) {
      if ($('.actions button:not([disabled])').length === 0) {
        return undefined;
      }

      var confirmation_message = 'You have unsaved changes. Click cancel to go back and save your changes by clicking the green checkmarks.';

      ( e || window.event ).returnValue = confirmation_message; //Gecko + IE

      return confirmation_message; //Gecko + Webkit, Safari, Chrome etc.
    });
  };

  $(document).ready(function() {
    var name_row = $('#name-row');
    if (name_row.length) {
      var first_name_field = $('#field-first-name');
      var last_name_field = $('#field-last-name');
      var name_row_button = name_row.find('button');

      var func_name_change = function() {
        check_fields([first_name_field, last_name_field], name_row_button);
      };

      first_name_field.on('change', func_name_change);
      first_name_field.on('blur', func_name_change);
      first_name_field.on('keyup', func_name_change);
      last_name_field.on('change', func_name_change);
      last_name_field.on('blur', func_name_change);
      last_name_field.on('keyup', func_name_change);

      name_row_button.click(function(e) {
        e.preventDefault();

        if (first_name_field.val() !== first_name_field.data('initial-value') || last_name_field.val() !== last_name_field.data('initial-value')) {
          open_please_wait();

          var form = name_row_button.closest('form');
          var send_data = {
            action: 'update_name_field',
            application_nonce: facilitator_admin_vars.application_nonce,
            first_name: first_name_field.val(),
            last_name: last_name_field.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            close_open_modal();
            response = JSON.parse(response);
            if (response.status) {
              after_fields_changed([first_name_field,
                last_name_field], name_row_button);
            } else {
              display_error(response.reason);
            }
          });
        }
      });
    }

    var email_row = $('#email-row');
    if (email_row.length) {
      var email_field = $('#field-email');
      var email_row_button = email_row.find('button');
      var func_email_change = function() {
        check_fields([email_field], email_row_button);
      };

      email_field.on('change', func_email_change);
      email_field.on('blur', func_email_change);
      email_field.on('keyup', func_email_change);

      email_row.find('button').click(function(e) {
        e.preventDefault();

        if (email_field.val() !== email_field.data('initial-value')) {
          open_please_wait();

          var form = email_row_button.closest('form');
          var send_data = {
            action: 'update_email_field',
            application_nonce: facilitator_admin_vars.application_nonce,
            email: email_field.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            close_open_modal();
            response = JSON.parse(response);
            if (response.status) {
              after_fields_changed([email_field], email_row_button);
            } else {
              display_error(response.reason);
            }
          });
        }
      });
    }

    var country_row = $('#country-row');
    var state_row = $('#state-row');
    var city_row = $('#city-row');
    if (country_row.length && state_row.length && city_row.length) {
      var country_select = country_row.find('select');
      var country_row_button = country_row.find('button');
      var form = country_row_button.closest('form');

      var state_select = state_row.find('select');
      var state_row_button = state_row.find('button');

      var city_select = city_row.find('select');
      var city_row_button = city_row.find('button');

      state_select.select2();
      city_select.select2();

      var func_country_row_change = function() {
        if (country_select.val() === country_select.data('initial-value')) {
          country_row_button.attr('disabled', true);
        } else {
          country_row_button.attr('disabled', false);
          city_select.html('');
          open_please_wait();

          var form = country_row_button.closest('form');
          var send_data = {
            action: 'get_states',
            application_nonce: facilitator_admin_vars.application_nonce,
            country: country_select.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            close_open_modal();

            response = JSON.parse(response);
            if (response.status) {
              state_select.html('');
              var existing_values = state_select.val();
              if (response.has_states) {
                $.each(response.data, function() {
                  var option = $('<option />').val(this.SUCode).html(this.SUName);
                  if (existing_values.includes(this.SUCode)) {
                    option.attr('selected', true);
                  }
                  state_select.append(option);
                });
              } else {
                state_select.append($('<option />').val('N/A').html('N/A').attr('selected', true));
                var existing_city_values = city_select.val();
                $.each(response.data, function() {
                  var option = $('<option />').val(response.data.name).html(response.data.name);
                  if (existing_city_values.includes(response.data.name)) {
                    option.attr('selected', true);
                  }
                  city_select.append('option');
                });
              }
            }

            city_select.trigger('change');
            state_select.trigger('change');
          });
        }
      };

      country_select.on('change', func_country_row_change);

      country_row_button.click(function(e) {
        e.preventDefault();

        if (country_select.val() !== country_select.data('initial-value')) {
          open_please_wait();

          var send_data = {
            action: 'update_country_field',
            application_nonce: facilitator_admin_vars.application_nonce,
            country: country_select.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            close_open_modal();

            response = JSON.parse(response);
            if (response.status) {
              after_fields_changed([country_select], country_row_button);
            } else {
              display_error(response.reason);
            }
          });
        }
      });

      var func_state_row_change = function() {
        if (JSON.stringify(state_select.val().sort()) === JSON.stringify(state_select.data('initial-value').sort())) {
          state_row_button.attr('disabled', true);
        } else {
          state_row_button.attr('disabled', false);

          open_please_wait();

          var send_data = {
            action: 'get_cities',
            application_nonce: facilitator_admin_vars.application_nonce,
            country: country_select.val(),
            states: state_select.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            response = JSON.parse(response);
            if (response.status) {
              var existing_values = city_select.val();
              city_select.html('');
              $.each(response.data, function() {
                var option = $('<option>').val(this.id).html(this.name);
                if (existing_values.includes(this.id)) {
                  option.attr('selected', true);
                }
                city_select.append(option);
              });
            }
            close_open_modal();
            city_select.trigger('change');
          });
        }
      };

      state_select.on('change', func_state_row_change);

      state_row_button.click(function(e) {
        e.preventDefault();

        if (JSON.stringify(state_select.val().sort()) !== JSON.stringify(state_select.data('initial-value').sort())) {
          open_please_wait();

          var form = state_row_button.closest('form');
          var send_data = {
            action: 'update_state_field',
            application_nonce: facilitator_admin_vars.application_nonce,
            state: state_select.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            close_open_modal();

            response = JSON.parse(response);
            if (response.status) {
              after_fields_changed([state_select], state_row_button);
            } else {
              display_error(response.reason);
            }
          });
        }
      });

      var func_city_row_change = function() {
        if (JSON.stringify(city_select.val().sort()) === JSON.stringify(city_select.data('initial-value').sort())) {
          city_row_button.attr('disabled', true);
        } else {
          city_row_button.attr('disabled', false);
        }
      };

      city_select.on('change', func_city_row_change);

      city_row_button.click(function(e) {
        e.preventDefault();

        if (JSON.stringify(city_select.val().sort()) !== JSON.stringify(city_select.data('initial-value').sort())) {
          open_please_wait();

          var form = city_row_button.closest('form');
          var send_data = {
            action: 'update_city_field',
            application_nonce: facilitator_admin_vars.application_nonce,
            city: city_select.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            close_open_modal();

            response = JSON.parse(response);
            if (response.status) {
              after_fields_changed([city_select], city_row_button);
            } else {
              display_error(response.reason);
            }
          });
        }
      });
    }

    var about_me_row = $('#about-me-row');
    if (about_me_row.length) {
      var about_me_field = $('#field-about-me');
      var about_me_row_button = about_me_row.find('button');
      var func_about_me_change = function() {
        check_fields([about_me_field], about_me_row_button);
      };

      about_me_field.on('change', func_about_me_change);
      about_me_field.on('blur', func_about_me_change);
      about_me_field.on('keyup', func_about_me_change);

      about_me_row_button.click(function(e) {
        e.preventDefault();

        if (about_me_field.val() !== about_me_field.data('initial-value')) {
          open_please_wait();

          var form = about_me_row_button.closest('form');
          var send_data = {
            action: 'update_about_me_field',
            application_nonce: facilitator_admin_vars.application_nonce,
            about_me: about_me_field.val(),
            user_id: form.data('user-id'),
            page_id: form.data('page-id'),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            close_open_modal();
            response = JSON.parse(response);
            if (response.status) {
              after_fields_changed([about_me_field], about_me_row_button);
            } else {
              display_error(response.reason);
            }
          });
        }
      });
    }

    var favorite_row = $('#favorite-row');
    if (favorite_row.length) {
      var favorite_field = $('#field-favorite');
      var favorite_row_button = favorite_row.find('button');
      var func_favorite_change = function() {
        check_fields([favorite_field], favorite_row_button);
      };

      favorite_field.on('change', func_favorite_change);
      favorite_field.on('blur', func_favorite_change);
      favorite_field.on('keyup', func_favorite_change);

      favorite_row.find('button').click(function(e) {
        e.preventDefault();
        open_please_wait();

        var form = favorite_row_button.closest('form');
        var send_data = {
          action: 'update_favorite_field',
          application_nonce: facilitator_admin_vars.application_nonce,
          favorite: favorite_field.val(),
          user_id: form.data('user-id'),
          page_id: form.data('page-id'),
        };

        $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
          close_open_modal();
          response = JSON.parse(response);
          if (response.status) {
            after_fields_changed([favorite_field], favorite_row_button);
          } else {
            display_error(response.reason);
          }
        });
      });
    }

    var got_out_of_row = $('#got-out-of-row');
    if (got_out_of_row.length) {
      var got_out_of_field = $('#field-got-out-of');
      var got_out_of_row_button = got_out_of_row.find('button');
      var func_got_out_of_change = function() {
        check_fields([got_out_of_field], got_out_of_row_button);
      };

      got_out_of_field.on('change', func_got_out_of_change);
      got_out_of_field.on('blur', func_got_out_of_change);
      got_out_of_field.on('keyup', func_got_out_of_change);

      got_out_of_row.find('button').click(function(e) {
        e.preventDefault();
        open_please_wait();

        var form = got_out_of_row_button.closest('form');
        var send_data = {
          action: 'update_got_out_of_field',
          application_nonce: facilitator_admin_vars.application_nonce,
          got_out_of: got_out_of_field.val(),
          user_id: form.data('user-id'),
          page_id: form.data('page-id'),
        };

        $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
          close_open_modal();
          response = JSON.parse(response);
          if (response.status) {
            after_fields_changed([got_out_of_field], got_out_of_row_button);
          } else {
            display_error(response.reason);
          }
        });
      });
    }

    var who_i_am_row = $('#who-i-am-row');
    if (who_i_am_row.length) {
      var who_i_am_field = $('#field-who-i-am');
      var who_i_am_row_button = who_i_am_row.find('button');
      var func_who_i_am_change = function() {
        check_fields([who_i_am_field], who_i_am_row_button);
      };

      who_i_am_field.on('change', func_who_i_am_change);
      who_i_am_field.on('blur', func_who_i_am_change);
      who_i_am_field.on('keyup', func_who_i_am_change);

      who_i_am_row_button.click(function(e) {
        e.preventDefault();
        open_please_wait();

        var form = who_i_am_row_button.closest('form');
        var send_data = {
          action: 'update_who_i_am_field',
          application_nonce: facilitator_admin_vars.application_nonce,
          who_i_am: who_i_am_field.val(),
          user_id: form.data('user-id'),
          page_id: form.data('page-id'),
        };

        $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
          close_open_modal();
          response = JSON.parse(response);
          if (response.status) {
            after_fields_changed([who_i_am_field], who_i_am_row_button);
          } else {
            display_error(response.reason);
          }
        });
      });
    }

    var photo_row = $('#photo-row');
    if (photo_row.length) {
      var photo_field = photo_row.find('input');
      var photo_row_button = photo_row.find('button');

      var func_photo_change = function() {
        if (photo_field.val()) {
          photo_row_button.attr('disabled', false);
        } else {
          photo_row_button.attr('disabled', true);
        }
      };

      photo_field.on('change', func_photo_change);

      photo_row_button.click(function(e) {
        e.preventDefault();
        open_please_wait();

        var form = who_i_am_row_button.closest('form');
        var fd = new FormData();

        fd.append('action', 'update_facilitator_photo');
        fd.append('application_nonce', facilitator_admin_vars.application_nonce);
        fd.append('photo', photo_field[0].files[0], photo_field[0].files[0].name);
        fd.append('user_id', form.data('user-id'));
        fd.append('page_id', form.data('page-id'));

        $.ajax({
          url: facilitator_admin_vars.ajaxurl,
          type: 'post',
          data: fd,
          contentType: false,
          processData: false,
          async: true,
          cache: false,
          timeout: 60000,
          success: function(response) {
            close_open_modal();
            response = JSON.parse(response);
            if (response.status) {
              photo_row_button.attr('disabled', true);
              photo_field.val('');
              var field_row = photo_field.closest('.fields');
              field_row.find('img').remove();
              field_row.append(response.image);
            } else {
              display_error(response.reason);
              photo_row_button.attr('disabled', false);
            }
          },
        });

      });
    }

    var eventbrite_url_row = $('#eventbrite-url-row');
    if (eventbrite_url_row.length) {
      var eventbrite_url_field = $('#field-eventbrite-url');
      var eventbrite_url_row_button = eventbrite_url_row.find('button');
      var func_eventbrite_url_change = function() {
        check_fields([eventbrite_url_field], eventbrite_url_row_button);
      };

      eventbrite_url_field.on('change', func_eventbrite_url_change);
      eventbrite_url_field.on('blur', func_eventbrite_url_change);
      eventbrite_url_field.on('keyup', func_eventbrite_url_change);

      eventbrite_url_row.find('button').click(function(e) {
        e.preventDefault();
        open_please_wait();

        var form = eventbrite_url_row_button.closest('form');
        var send_data = {
          action: 'update_eventbrite_url_field',
          application_nonce: facilitator_admin_vars.application_nonce,
          eventbrite_url: eventbrite_url_field.val(),
          user_id: form.data('user-id'),
          page_id: form.data('page-id'),
        };

        $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
          close_open_modal();
          response = JSON.parse(response);
          if (response.status) {
            after_fields_changed([eventbrite_url_field], eventbrite_url_row_button);
          } else {
            display_error(response.reason);
          }
        });
      });
    }

    var d_country_select = $('select.divi-acf.et_pb_contact_select[data-name=country]');
    var d_state_select = $('select.divi-acf.et_pb_contact_select[data-name=state]');
    var d_city_select = $('select.divi-acf.et_pb_contact_select[data-name=city]');

    if (d_country_select.length && d_state_select.length && d_city_select.length) {
      d_country_select.find(':not(:first-child)').remove();
      d_state_select.find(':not(:first-child)').remove();
      d_city_select.find(':not(:first-child)').remove();

      $.each(window.facilitator_ld, function(country_code, country_data) {
        d_country_select.append($('<option />').val(country_code).html(country_data.name));
      });

      d_country_select.change(function() {
        d_state_select.find(':not(:first-child)').remove();
        $.each(window.facilitator_ld[d_country_select.val()].states, function(state_code,
          arr_values) {
          d_state_select.append($('<option />').val(state_code).html(arr_values['name']));
        });
      });

      d_state_select.change(function() {
        d_city_select.find(':not(:first-child)').remove();
        $.each(window.facilitator_ld[d_country_select.val()].states[d_state_select.val()].cities, function(city_id,
          city_name) {
          d_city_select.append($('<option />').val(city_id).html(city_name));
        });
      });

      //var name_search = $('.post-type-archive-facilitators.et-db #et-boc .et-l .et_pb_de_mach_filter_posts_0_tb_body .divi-filter-item');
      //name_search.attr('placeholder', 'Name Search');

      var filter_params = $('.post-type-archive-facilitators.et-db .filter-param-tags');

      // The node to be monitored
      var target = filter_params[0];

      // Create an observer instance
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          var newNodes = mutation.addedNodes;
          if (newNodes !== null) {
            var nodes = $(newNodes);
            nodes.each(function() {
              var node = $(this);
              var str_filter = node.data('filter');
              if (str_filter.startsWith('state_')) {
                node.html('State: ' + d_state_select.find('option:selected').html());
              } else if (str_filter.startsWith('city_')) {
                node.html('City: ' + d_city_select.find('option:selected').html());
              }
            });
          }
        });
      });

      // Configuration of the observer:
      var config = {
        attributes: true,
        childList: true,
        characterData: true,
      };

      // Pass in the target node, as well as the observer options
      observer.observe(target, config);

    }

    var g_country_select = $('#input_1_16');
    var g_state_select = $('#input_1_6');
    var g_city_select = $('#input_1_7');

    if (g_country_select.length && g_state_select.length && g_city_select.length) {

      g_state_select.select2();
      g_city_select.select2();

      g_country_select.change(function() {
        open_please_wait();
        var send_data = {
          action: 'get_states',
          application_nonce: facilitator_admin_vars.application_nonce,
          country: g_country_select.val(),
        };

        $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
          close_open_modal();

          response = JSON.parse(response);
          if (response.status) {
            g_state_select.html('');
            g_city_select.html('');

            if (response.has_states) {
              $.each(response.data, function() {
                g_state_select.append(new Option(this.SUName, this.SUCode, false, false));
              });
            } else {
              g_state_select.append($('<option />').val('N/A').html('N/A').attr('selected', true));
              $.each(response.data, function() {
                g_city_select.append($('<option />').val(response.data.name).html(response.data.name));
              });
            }
          }

          g_state_select.trigger('change');
        });
      });

      g_state_select.on('change', function() {
        if (g_state_select.val()) {
          open_please_wait();
          var send_data = {
            action: 'get_cities',
            application_nonce: facilitator_admin_vars.application_nonce,
            country: g_country_select.val(),
            states: g_state_select.val(),
          };

          $.post(facilitator_admin_vars.ajaxurl, send_data, function(response) {
            response = JSON.parse(response);
            if (response.status) {
              var existing_values = g_city_select.val();
              g_city_select.html('');
              $.each(response.data, function() {
                var option = $('<option>').val(this.id).html(this.name);
                if (existing_values.includes(this.id)) {
                  option.attr('selected', true);
                }
                g_city_select.append(option);
              });
            }
            close_open_modal();
            g_city_select.trigger('change');
          });
        }
      });
    }
  });
} )(jQuery);



// WEBPACK FOOTER //
// ./scripts/profile.js